const user_scopes = {
    descriptions: {
        custom_data: 'Datele tale personalizate',
        email: 'Adresa ta de e-mail',
        phone: 'Numărul tău de telefon',
        profile: 'Numele tău, numele de utilizator, avatarul și alte informații de profil',
        roles: 'Rolurile tale',
        identities: 'Identitățile tale sociale conectate',
        'urn:logto:scope:organizations': 'Informațiile despre organizațiile tale',
        'urn:logto:scope:organization_roles': 'Rolurile tale în organizație',
        address: 'Adresa ta',
    },
};
export default Object.freeze(user_scopes);
